import CharacterLibrary from "../components/CharacterLibrary";

const Library = () => {

    return (
        <CharacterLibrary />
    )

}

export default Library;